import React from 'react';
import PropTypes from 'prop-types';
import CountryDisplay from 'components/CountryDisplay';
import { StyledGroupMemberDetails, DetailRow } from './styled';

const ApplicantDetails = ({ homeCountry, groupMember }) => {
  return (
    <StyledGroupMemberDetails>
      <DetailRow>
        <div>Home country</div>
        <CountryDisplay countryCode={homeCountry} variant="dark" />
      </DetailRow>
      <DetailRow>
        <div>Citizenship</div>
        <CountryDisplay
          countryCode={groupMember.citizenshipCountry || groupMember.citizenship}
          variant="dark"
        />
      </DetailRow>
      <DetailRow>
        <div>Email</div>
        <div>{groupMember.email}</div>
      </DetailRow>
    </StyledGroupMemberDetails>
  );
};

ApplicantDetails.propTypes = {
  homeCountry: PropTypes.string.isRequired,
  groupMember: PropTypes.object.isRequired
};

export default ApplicantDetails;
